module.exports = __webpack_public_path__ + "static/media/warning-triangle-green.a20eb17b.svg";